import styled from 'styled-components'

export const Container = styled.div`
  cursor: pointer;
  border: 4px solid transparent;
  border-radius: ${props => props.theme.primitives.radius.radius3};
  &:hover {
    border-color: ${props => props.theme.colors.info.default};
  }
`

export const Header = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius3};
  align-items: center;
  background-color: ${props => props.theme.colors.background.secondary};
`

export const BodyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${props => `12px ${props.theme.spacing.sp8}`};
`

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const StoreInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const OrderPriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
